import ProtoBufService from './ProtoBufService'
import * as CameraStatusPB from './libs/messaging/camera_status_pb'
import * as CameraSettingPB from './libs/messaging/camera_settings_pb'
import * as LiveControlPB from './libs/messaging/live_control_pb'
import { assignPayloadByDict } from './utils'
import * as CameraInfoPB from './libs/messaging/camera_info_pb'
import { CameraRuntimeStatus as CameraRuntimeStatusPB } from './libs/messaging/camera_status_pb'

export namespace CameraStatus {

  export enum Membership {
    FREE = 0,
    FREE_2 = 1,
    PLUS = 4,
    PLUS_2 = 5,
    PREMIUM = 8,
    PREMIUM_2 = 9,
  }
  
  export class CameraStatusService extends ProtoBufService {
    constructor () {
      super()
      this.service = ProtoBufService.ServiceType.CAMERA_STATUS
    }

    respondLiveSessionStatus(id: number, status: CameraStatusPB.LiveSessionStatus.AsObject) {
      const payload = new CameraStatusPB.LiveSessionStatus()
      
      assignPayloadByDict(payload, {
        logs: status.logs, 
        resolution_state: status.resolutionState, 
        width: status.width, 
        height: status.height
      })
      
      // if (status.resolutionState) {
      //   const resCtr = new LiveControlPB.ResolutionControl()
      //   resCtr.setState(status.resolutionState)
      //   payload.setResolutionState(resCtr)
      // }

      if (status.focusState !== undefined) {
        const fstate = new LiveControlPB.FocusControl.FocusState()
        assignPayloadByDict(fstate, status.focusState)
        payload.setFocusState(fstate)
      }

      if (status.zoomState !== undefined) {
        const zm = new LiveControlPB.ZoomControl.ZoomState()
        assignPayloadByDict(zm, status.zoomState)
        payload.setZoomState(zm)
      }

      if (status.recordingState !== undefined) {
        const rec = new CameraStatusPB.LiveSessionStatus.CameraRecordingState()
        rec.setRecording(status.recordingState.recording)
        payload.setRecordingState(rec)
      }
      
      if (status.lowlightSetting !== undefined) {
        const lls = new CameraSettingPB.LowLightFilterSetting()
        assignPayloadByDict(lls, status.lowlightSetting)
        payload.setLowlightSetting(lls)
      }

      if (status.micSetting !== undefined) {
        const mic = new CameraSettingPB.CameraMicrophoneSetting()
        mic.setEnabled(status.micSetting.enabled)
        payload.setMicSetting(mic)
      }

      if (status.featureAvail !== undefined) {
        const feat = new CameraStatusPB.LiveSessionStatus.LiveFeatureAvailability()
        assignPayloadByDict(feat, status.featureAvail)
        payload.setFeatureAvail(feat)
      }
      // ! not handling ptt_state/ siren_state/ orientation_state/ torch_state/ lens_setting, since web camera don't supporting them
      return this.request(id, CameraStatusPB.CameraStatusControls.LIVE_SESSION_STATUS, payload)
    }

    sendCameraRuntimeStatus(id: number, status: CameraRuntimeStatusPB.AsObject) {
      // const payload = new CameraInfoPB.CameraStatusResponse()
      const statusPB = new CameraRuntimeStatusPB()

      let objs = {
        powerStatus: new CameraRuntimeStatusPB.PowerSupplyStatus(),
        detectorStatus: new CameraRuntimeStatusPB.DetectorStatus(),
        healthStatus: new CameraRuntimeStatusPB.HealthStatus(),
      }
      let primals = {
        settingsRevision: status.settingsRevision,
        disabled: status.disabled,
        micOff: status.micOff,
        connectedUsersList: status.connectedUsersList,
        statusCodesList: status.statusCodesList,
        membershipStatus: status.membershipStatus,
      }
      for (const key in objs) {
        // @ts-ignore: TS7053
        assignPayloadByDict(objs[key], status[key])
      }

      assignPayloadByDict(statusPB, primals)
      assignPayloadByDict(statusPB, objs)
      return this.request(id, CameraStatusPB.CameraStatusControls.CAMERA_RUNTIME_STATUS, statusPB)
    }
    
    static isPremium(membership: 0 | 1 | 4 | 5 | 8 | 9) {
      switch (membership) {
        case CameraStatusPB.CameraRuntimeStatus.Membership.FREE:
          return false
        case CameraStatusPB.CameraRuntimeStatus.Membership.FREE_2:
          return false
        case CameraStatusPB.CameraRuntimeStatus.Membership.PLUS:
          return false
        case CameraStatusPB.CameraRuntimeStatus.Membership.PLUS_2:
          return false
        case CameraStatusPB.CameraRuntimeStatus.Membership.PREMIUM:
          return true
        case CameraStatusPB.CameraRuntimeStatus.Membership.PREMIUM_2:
          return true
      }
    }

    onMessage = ({ type, control, payload }: { type: 0 | 1, control: number, payload: Uint8Array }) => {
      let data;
      switch (control) {
        case CameraStatusPB.CameraStatusControls.CAMERA_RUNTIME_STATUS:
          data = CameraStatusPB.CameraRuntimeStatus.deserializeBinary(payload)
          return {
            type: 'cameraRuntimeStatus',
            data: data.toObject()
          }
        case CameraStatusPB.CameraStatusControls.LIVE_SESSION_STATUS:
          data = CameraStatusPB.LiveSessionStatus.deserializeBinary(payload)
          return {
            type: 'liveSessionStatus',
            data: data.toObject()
          }
        default:
          break
      }
      return null
    }
  }

}

export default CameraStatus.CameraStatusService